<script lang="ts" setup>
const appUserDataStore = useAppUserDataStore();
const { isUserAdmin, isUserSystemAdmin, hasPermission } =
  storeToRefs(appUserDataStore);

onMounted(() => {});

const tabs = computed(() => {
  let baseTabs: Tabs = [
    {
      label: "General",
      key: "/settings",
    },
  ];

  if (
    hasPermission.value("manage-app-data", {
      allowAdmin: true,
    })
  ) {
    baseTabs.push({
      label: "App Data",
      key: "/settings/app-data",
    });
  }

  if (
    hasPermission.value("manage-checklists", {
      allowSysAdmin: true,
    })
  ) {
    baseTabs.push({
      label: "Checklists",
      key: "/settings/checklists",
    });
  }

  if (
    hasPermission.value("view-reports", {
      allowSysAdmin: true,
    })
  ) {
    baseTabs.push({
      label: "Reports",
      key: "/settings/reports",
    });
  }

  return baseTabs;
});

const onTabChange = (newKey: any) => {
  navigateTo(newKey, { replace: true });
};
</script>

<template>
  <NuxtLayout name="scaffold">
    <template #app-bar-title>
      <span class="text-h5"> Settings </span>
    </template>
    <div class="flex flex-col h-full bg-surface p-4">
      <div>
        <BaseTabBar
          v-if="tabs.length > 1"
          :tabs="tabs"
          :model-value="$route.path"
          @update:model-value="onTabChange"
        />
      </div>
      <div class="grow min-h-0 overflow-auto">
        <slot />
      </div>
    </div>
  </NuxtLayout>
</template>

<style scoped></style>
